import React, {
  useState,
  useMemo,
  useImperativeHandle,
  forwardRef,
} from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import classes from "utils/classes"
import ArrowIcon from "./assets/arrow.inline.svg"
import ToggleIcon from "./assets/toggle.inline.svg"
import styles from "./Filters.module.scss"

const Filters = forwardRef(
  ({ title, allItemsTitle, items, selected, onChange }, ref) => {
    const [opened, setOpened] = useState(true)

    useImperativeHandle(ref, () => ({
      minimize: () => {
        setOpened(false)
      },
    }))

    const totalCount = useMemo(
      () => items.reduce((acc, it) => acc + it.count, 0),
      [items]
    )

    const handleToggle = () => {
      setOpened(state => !state)
    }

    const handleSelect = item => () => {
      onChange?.(item)
      setOpened(true)
    }

    return (
      <>
        <button
          onClick={handleToggle}
          className={`${styles.toggler} ${!opened ? styles.closed : ""}`}
          type="button"
        >
          <ToggleIcon />
        </button>
        <div className={`${styles.wrapper} ${!opened ? styles.closed : ""}`}>
          <div className={styles.events}>
            <h2 className={styles.title}>{title}</h2>
            <h2 className={styles.mobileTitle}>
              <span>{selected?.title || allItemsTitle}</span>
            </h2>
            <div className={styles.list}>
              <div
                className={classes(styles.item, !selected && styles.selected)}
              >
                <div>
                  <button
                    onClick={handleSelect(null)}
                    className={styles.name}
                    type="button"
                  >
                    {allItemsTitle}
                  </button>
                </div>
                <button
                  onClick={handleSelect(null)}
                  className={styles.count}
                  type="button"
                >
                  {totalCount}
                </button>
              </div>
              {items.map(item => (
                <div
                  key={item.id}
                  className={classes(
                    styles.item,
                    selected?.id === item.id && styles.selected
                  )}
                >
                  <div>
                    <button
                      onClick={handleSelect(item)}
                      className={styles.name}
                      type="button"
                    >
                      {item.title}
                    </button>
                    {Boolean(item.slug) && (
                      <Link to={`${item.slug}`} target="_blank">
                        Подробнее об акции <ArrowIcon />
                      </Link>
                    )}
                  </div>
                  <button
                    onClick={handleSelect(item)}
                    className={styles.count}
                    type="button"
                  >
                    {item.count || 0}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    )
  }
)

Filters.propTypes = {
  title: PropTypes.string.isRequired,
  allItemsTitle: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      slug: PropTypes.string,
    })
  ),
  totalCount: PropTypes.number,
  selected: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    slug: PropTypes.string,
  }),
  onChange: PropTypes.func,
}

export default Filters
